/**
 * @author Jas
 * @email 83673@global.ul.com
 * @create date 2021-05-07
 * @desc activity tracker component (product classification)
 */
<template>
  <div class="content-wrappper">
    <div class="row mtl-25-10" v-if="selectedMenu == 'rationales'">
          <div class="col-md-10 col-sm-10 col-xs-12">
            <a href="javascript:void(0);" class="sub-heading" @click="routeProdClass()">
                <i class="fa fa-angle-left"></i>Product Classification
            </a>
          </div>
    </div>
    <div class="row tracker-container">
      <div class="col-xs-12 col-sm-12 box-body">
        <!-- count and deactivate and active buttons -->
        <product-classification-tabs
          :resetSearch="resetSearch"
          :rationaleCount="total"
          @selectedMenu="selectedMenuItem"
          :activeItem="selectedMenu"
        ></product-classification-tabs>
        <div class="row">
          <template v-if="selectedMenu == 'rationales'">
            <product-classification-rationale-grid
               @pagechanged="pagechanged"
              v-model="selectedRationales"
              ref="accountsList"
            ></product-classification-rationale-grid>
          </template>
        </div>
      </div>
    </div>
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>

<script>
import Loader from '../UIComponents/Loader.vue';
import ProductClassificationTabs from './ProductClassificationTabs.vue';
import ProductClassificationRationaleGrid from './ProductClassificationRationaleGrid.vue';
import { getAllAccount, getAllUsers, exportUsers } from '../../apis/activityTracker';
import { getServiceDesc } from '../../apis/marketPlace';
import { getClassificationRationaleData } from '../../apis/prodClassification';

const XLSXImport = () => import('xlsx');

export default {
  props: ['roleId', 'account_id', 'userId'],
  data() {
    return {
      headers: [],
      loaderStatus: false,
      selectedMenu: '',
      accountList: [],
      userList: [],
      logInActivity: [],
      searchText: '',
      selectedAccounts: [],
      selectedUsers: [],
      selectedRationales: [],
      TypeOf: '',
      filterObj: {},
      totalRecordsCount: 0,
      fromRecords: 1,
      totalPages: 1,
      total: 0,
      maxVisiblePages: 4,
      perPage: 50,
      currentPage: 1,
      servicesList: [],
      includeDeactivatedAccounts: false,
      includeDeactivatedUsers: false,
      preAccountSelect: '',
      preUserSelect: '',
      placeholder: '',
      userSearchText: 'Search with User Id/ Name/ E-mail Id/ Account Name',
      accountSearchText: 'Search with Account Id/ Company Name',
      XLSX: null,
    };
  },
  components: {
    Loader,
    ProductClassificationRationaleGrid,
    ProductClassificationTabs,
  },
  async created() {
    await this.getServiceDesc();
    if (this.$route.params.selectedMenu) {
      this.selectedMenu = this.$route.params.selectedMenu;
    } else {
      this.selectedMenu = 'rationales';
    }
    this.$nextTick(async () => {
      this.total = 0;
      if (this.selectedMenu === 'users') {
        this.placeholder = this.userSearchText;
        if (this.$route.params.filter && this.$route.params.selectedMenu === 'users') {
          this.preUserSelect = this.$route.params;
        } else {
          this.validateUserDeactivatedInclude();
          await this.getUsersList();
        }
      } else if (this.selectedMenu === 'rationales') {
        this.total = 10;
        this.placeholder = this.accountSearchText;
        if (this.$route.params.filter && this.$route.params.selectedMenu === 'rationales') {
          this.preAccountSelect = this.$route.params;
        } else {
          // this.validateAccountDeactivatedInclude();
          await this.getRationaleList();
        }
      } else if (this.selectedMenu === 'accounts') {
        this.placeholder = this.accountSearchText;
        if (this.$route.params.filter && this.$route.params.selectedMenu === 'accounts') {
          this.preAccountSelect = this.$route.params;
        } else {
          this.validateAccountDeactivatedInclude();
          await this.getAccountList();
        }
      }
    });
    this.XLSX = (await XLSXImport()).default;
  },
  methods: {
    reset() {
      this.currentPage = 1;
      this.accountList = [];
      this.headers = [];
      this.userList = [];
      this.filterObj = {};
      this.includeDeactivatedAccounts = false;
      this.includeDeactivatedUsers = false;
      this.searchText = '';
      this.preUserSelect = {};
      this.preAccountSelect = {};
    },
    capitalizeHeader(value) {
      const returnVal = value.replace('_', ' ').toString();
      return returnVal
        .toLowerCase()
        .split(' ')
        .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
        .join(' ');
    },
    async getServiceDesc() {
      this.loaderStatus = true;
      this.servicesList = await getServiceDesc();
      this.loaderStatus = false;
    },
    async exportUsers(totalRecordsCount) {
      const formData = {
        from: 1,
        to: totalRecordsCount,
      };
      this.loaderStatus = true;
      const usersList = await exportUsers(formData);
      this.loaderStatus = false;
      if (usersList) {
        if (usersList.total_records_count > totalRecordsCount) {
          this.totalRecordsCount = usersList.total_records_count;
          this.exportUsers(this.totalRecordsCount);
        } else {
          this.exportUsersExcelSheet(usersList.result_data);
        }
      } else {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Error while exporting!',
          group: 'custom-notification',
        });
      }
    },
    async exportUsersExcelSheet(users) {
      const data = this.XLSX.utils.json_to_sheet(users);
      const wb = this.XLSX.utils.book_new();
      this.XLSX.utils.book_append_sheet(wb, data, 'data');
      this.XLSX.writeFile(wb, 'UsersList.xlsx');
    },
    async exportAccounts(totalRecordsCount) {
      const formData = {
        pagination: {
          from: 1,
          to: totalRecordsCount,
        },
      };
      this.loaderStatus = true;
      const accountList = await getAllAccount(formData);
      this.loaderStatus = false;
      if (accountList) {
        if (accountList.total_records_count > totalRecordsCount) {
          this.totalRecordsCount = accountList.total_records_count;
          this.exportAccounts(this.totalRecordsCount);
        } else {
          await this.exportAccountsExcelSheet(accountList.result_data);
        }
      } else {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Error while exporting!',
          group: 'custom-notification',
        });
      }
    },
    async exportAccountsExcelSheet(accounts) {
      const exportAllAccounts = [];
      accounts.forEach((account) => {
        const acc = account;
        acc.rep_client = account.rep_client ? 'Rep' : 'Commercial';
        acc.deactivated = account.deactivated ? 'true' : 'false';
        const customizeaccount = {};
        Object.keys(acc).forEach((key) => {
          customizeaccount[this.capitalizeHeader(key)] = acc[key];
        });
        exportAllAccounts.push(customizeaccount);
      });
      const data = this.XLSX.utils.json_to_sheet(exportAllAccounts);
      const wb = this.XLSX.utils.book_new();
      this.XLSX.utils.book_append_sheet(wb, data, 'data');
      this.XLSX.writeFile(wb, 'accountsList.xlsx');
    },
    getFormData() {
      const formData = {
        pagination: {
          from: this.fromRecords,
          to: this.perPage,
        },
      };
      this.searchText = this.searchText ? (formData.search = this.searchText.trim()) : '';
      this.filterObj = Object.keys(this.filterObj).length !== 0
        ? (formData.filter = this.filterObj)
        : {};
      return formData;
    },
    async getAccountList() {
      const formData = this.getFormData();
      this.loaderStatus = true;
      const records = await getAllAccount(formData);
      this.loaderStatus = false;
      if (records) {
        this.accountList = records.result_data;
        this.headers = records.total_records_count !== 0
          ? Object.keys(this.accountList[0])
          : this.headers;
        this.total = records.total_records_count;
        this.totalRecordsCount = this.total > this.totalRecordsCount
          ? this.total
          : this.totalRecordsCount;
        this.totalPages = Math.ceil(this.total / this.perPage);
      }
    },
    async getRationaleList() {
      this.loaderStatus = true;
      const accountId = sessionStorage.getItem('getAccountDetailsId');
      const response = await getClassificationRationaleData(accountId);
      this.loaderStatus = false;
      this.servicesList = response.data || [];
      this.total = this.servicesList.length;
    },
    async getUsersList() {
      const formData = this.getFormData();
      this.loaderStatus = true;
      const response = await getAllUsers(formData);
      this.loaderStatus = false;
      if (response) {
        this.userList = response.result_data || [];
        this.headers = response.total_records_count !== 0 && this.userList[0]
          ? Object.keys(this.userList[0])
          : this.headers;
        this.total = response.total_records_count;
        this.totalRecordsCount = this.total > this.totalRecordsCount
          ? this.total
          : this.totalRecordsCount;
        this.totalPages = Math.ceil(this.total / this.perPage);
      }
    },
    async pagechanged(currentPage) {
      if (currentPage) this.currentPage = currentPage;
      this.fromRecords = this.currentPage * this.perPage - (this.perPage - 1);
      // if (this.selectedMenu === 'accounts') await this.getAccountList();
      // else if (this.selectedMenu === 'users') await this.getUsersList();
    },
    validateAccountDeactivatedInclude() {
      if (!this.includeDeactivatedAccounts) {
        this.filterObj.account_status = {
          active: true,
          deactivated: false,
        };
      }
      if (this.includeDeactivatedAccounts) {
        if (this.filterObj.account_status) delete this.filterObj.account_status;
      }
    },
    validateUserDeactivatedInclude() {
      if (!this.includeDeactivatedUsers) {
        this.filterObj.user_status = {
          active: true,
          deactivated: false,
        };
      }
      if (this.includeDeactivatedUsers) {
        if (this.filterObj.user_status) delete this.filterObj.user_status;
      }
    },
    async includeAccountsEvent() {
      this.validateAccountDeactivatedInclude();
      await this.pagechanged(1);
    },
    async includeUsersEvent() {
      this.validateUserDeactivatedInclude();
      await this.pagechanged(1);
    },
    async selectedMenuItem(menuItem) {
      this.reset();
      this.selectedMenu = menuItem;
      this.total = 0;
      /* if (this.selectedMenu === 'users') {
        this.placeholder = this.userSearchText;
        this.validateUserDeactivatedInclude();
        await this.getUsersList();
      } else if (this.selectedMenu === 'accounts') {
        this.validateAccountDeactivatedInclude();
        await this.getAccountList();
        this.placeholder = this.accountSearchText;
      } else */
      if (this.selectedMenu === 'rationale') {
        // this.validateAccountDeactivatedInclude();
        await this.getRationaleList();
        this.placeholder = this.accountSearchText;
      }
    },
    async resetSearch() {
      this.searchText = '';
      await this.pagechanged(1);
    },
    async accountsFilterObject(data) {
      this.filterObj = {};
      if (data.flags.deactivated) {
        this.filterObj.account_status = {
          active:
            data.filter_account_status.account_status === 'active',
          deactivated:
            data.filter_account_status.account_status === 'deactivated',
        };
      }
      if (data.flags.user) {
        this.filterObj.account_type = {
          commercial:
            data.filter_account_type.account_type === 'commercial',
          rep: data.filter_account_type.account_type === 'rep',
        };
      }
      if (data.flags.service) {
        this.filterObj.services_registered = data.filter_selectedService.selectedService;
      }
      if (data.flags.date) {
        this.filterObj.date_created = {
          from: data.filter_date.from,
          to: data.filter_date.to,
        };
      }
      if (!data.flags.deactivated) {
        this.validateAccountDeactivatedInclude();
      }
      await this.pagechanged(1);
    },
    routeProdClass() {
      this.$router.push('/layout/accountdetails');
    },
    async usersFilterObject(data) {
      this.filterObj = {};
      if (data.flags.deactivated) {
        this.filterObj.user_status = {
          active:
            data.filter_user_status.user_status === 'active',
          deactivated:
            data.filter_user_status.user_status === 'deactivated',
        };
      }
      if (data.flags.user) {
        this.filterObj.account_type = {
          commercial:
            data.filter_account_type.account_type === 'commercial',
          rep: data.filter_account_type.account_type === 'rep',
        };
      }
      if (data.flags.confirmed) {
        this.filterObj.confirmed_status = {
          confirmed:
          data.filter_confirmed_type.selectedService === 'confirmed',
          unconfirmed: data.filter_confirmed_type.selectedService === 'unconfirmed',
        };
      }
      if (data.flags.date) {
        this.filterObj.date_created = {
          from: data.filter_date.from,
          to: data.filter_date.to,
        };
      }
      if (data.flags.confirmedDate) {
        this.filterObj.date_confirmed = {
          from: data.filter_confirmed_date.from,
          to: data.filter_confirmed_date.to,
        };
      }
      if (!data.flags.deactivated) {
        this.validateUserDeactivatedInclude();
      }
      await this.pagechanged(1);
    },
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification',
      });
    },
  },
};
</script>
<style scoped>

.tracker-container {
  margin-right: 0px;
  margin-left: 0px;
}
.activity-search-input > i.fa-search {
  position: absolute;
  top: 8px;
  left: 30px;
}
.box-body {
  padding-top: 15px;
}
.activity-search-input span.search-reset {
  top: 8px;
  right: 30px;
  font-size: 17px;
}
.total-count {
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-size: 24px;
  line-height: 28px;
}
.mtl-25-10 {
  margin: 25px 10px 0;
}
.user-button-group a {
  margin-left: 30px;
}
.pd-lt-0 {
  padding-left: 0px;
}
.activity-search-input {
  position: relative;
  float: left;
}
.sub-heading > i {
  margin-right: 6px;
}
.sub-heading {
  font-family: Roboto;
  font-style: normal;
  font-size: 18px;
  color: #0b3c61;
  cursor: pointer;
}
@media screen and (max-width: 567px) {
  .sm-wid-22 {
    width: 22%;
  }
}
@media (min-width: 568px) and (max-width: 767px) {
  .sm-wid-22 {
    width: 17%;
  }
}
@media screen and (max-width: 767px) {
  .users-group span {
    display: block;
  }
  .users-group .user-button-group {
    display: flex;
    justify-content: space-between;
    float: initial;
  }
  .user-button-group a {
    margin: 20px 0;
    display: inherit;
  }
  .user-button-group a img {
    margin-top: 2px;
  }
  .xs-pd-lt-0 {
    padding-left: 0px;
  }
  .xs-pd-rt-0 {
    padding-right: 0px;
  }
}
@media (min-width: 769px) and (max-width: 1199px) {
  .sm-wid-22 {
    width: 22%;
  }
}
</style>
